import React from 'react';

import { CloseBig } from '../../../icons';
import { IconButton } from '../../Button';

import { ModalContainerProps } from './ModalContainer.types';

import { ModalBody, ModalContent, ModalHeader, ModalHeaderText } from './ModalContainer.styles';

export function ModalContainer({
  style,
  title,
  children,
  size,
  hideCloseButton,
  onClose,
}: ModalContainerProps) {
  return (
    <ModalContent
      style={style}
      onClick={e => e.stopPropagation()}
      role="tmov-modal-container"
      size={size}
    >
      {title && (
        <ModalHeader>
          <ModalHeaderText>{title}</ModalHeaderText>
          {!hideCloseButton && onClose && (
            <IconButton
              role="btn-close-tmov-modal"
              icon={CloseBig}
              variant="text"
              iconSize={16}
              size="sm"
              onClick={onClose}
            />
          )}
        </ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
    </ModalContent>
  );
}
